<svelte:options accessors/>
<script lang="ts">
    import {createEventDispatcher, onMount} from "svelte";
    import NauiField from "../atoms/NauiField.svelte";

    export let isDisabled: boolean = false;
    export let term: string;
    export let label: string = 'Entidad';
    export let searchVal: string;
    export let items: Array<any> = [];
    export let key: string = 'name';
    export let searchPlaceholder: string = 'Ingrese código o nombre.';
    const dispatch = createEventDispatcher();
    let value;
    export let selectedItem;
    let timer;
    let show: boolean = false;

    export let selectedLabel: string = '';

    onMount(() => {
        updateSelectedItem();
    });

    const debounce = v => {
        clearTimeout(timer);
        timer = setTimeout(() => {
            term = v;
            dispatch('search', {
                term
            });
        }, 300);
    }

    function setSelected(item) {
        selectedItem = item;
        updateSelectedItem();
        show = false;
        dispatch('selected', item);
    }

    export function updateSelectedItem() {
        selectedLabel = selectedItem && key ? selectedItem[key] || '' : '';
    }
</script>
<div class="w-100" style="position:relative;">
    {#if isDisabled}
        <NauiField label={label}
                   value={selectedLabel}/>
    {:else}
        <div class="naui-field" class:active={!!selectedItem}>
            <div class="naui-field-back" class:fill={!!selectedItem}>
                <label class:focus={!!selectedItem}>{label}</label>
                <input class="naui-input w-100 cursor-pointer"
                       type="text"
                       readonly
                       value={selectedLabel}
                       placeholder={label}
                       on:click={()=>show=true}>
            </div>
        </div>
        {#if show && !isDisabled}
            <div class="background-results">
                <input class="naui-input w-100"
                       type="text"
                       placeholder={searchPlaceholder}
                       on:keyup={({ target: { value } }) => debounce(value)}
                       bind:value={searchVal}>
                {#if items?.length > 0}
                    {#each items as item}
                        <div class="result-entry py-ii" on:click={()=>setSelected(item)}>
                            {item.code}: {item.name}
                        </div>
                    {/each}
                {/if}
            </div>
            <div class="background-overlay" on:click={()=>show = false}>

            </div>
        {/if}
    {/if}
</div>

<style>
    .background-results {
        position: absolute;
        z-index: 12;
        max-height: 300px;
        background: #fff;
        padding: .5rem;
        border: 1px solid #ccc;
        border-radius: 5px;
        overflow-y: scroll;
        width: 100%;
    }

    .background-results .result-entry {
        cursor: pointer;
    }

    .background-results .result-entry:hover {
        background: rgba(0, 0, 0, 0.05);
    }

    .background-overlay {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 10;
        background: rgba(0, 0, 0, 0.02);
    }
</style>